import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { M3ButtonComponent } from '@shared/button/m3-button.component';

@Component({
  selector: 'app-microsoft-sign-in-button',
  imports: [M3ButtonComponent],
  template: `
    <app-m3-button
      variant="outlined"
      (click)="buttonClick.emit()"
      [disabled]="disabled()"
    >
      <svg
        class="microsoft-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23 23"
      >
        <path fill="#f35325" d="M1 1h10v10H1z" />
        <path fill="#81bc06" d="M12 1h10v10H12z" />
        <path fill="#05a6f0" d="M1 12h10v10H1z" />
        <path fill="#ffba08" d="M12 12h10v10H12z" />
      </svg>
      {{ buttonText() }}
    </app-m3-button>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .microsoft-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        vertical-align: middle;
      }
    `,
  ],
})
export class MicrosoftSignInButtonComponent {
  buttonText = input($localize`Mit Microsoft anmelden`);
  disabled = input(false);
  buttonClick = output<void>();
}
